import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// import { Form } from "react-bootstrap";
import { toast } from "react-toastify";
import CommonHeadingNBtns from "../common-components/CommonHeadingNBtns";
import SelectDropdown from "../components-react/SelectDropdown";
import { commonPostPutApi } from "../../redux/reducers/commonApiSlice";
import { offer_mapping_POST, offer_mapping_PUT } from "../../data/ApiEndpoints";
import { showConfirmAlert } from "../components-react/ReactAlert";
import {
  // fetchAllDraftPlansData,
  fetchPlansData,
} from "../../redux/plans-reducers/plansSlice";
import { selectGymData } from "../../redux/reducers/gymDataSlice";
import { fetchGymData } from "../../data/APIs";

export function validation(formValues) {
  let errors = {};

  const offerPriceNumber = parseFloat(formValues.offerPrice);
  const selectedPlanPriceNumber = formValues.isCustomAmount
    ? parseFloat(formValues.customMaxSellingPrice)
    : parseFloat(formValues.selestecPlan?.price);

  if (!formValues.selectedGym) {
    errors.selectedGym = "required";
  }

  if (!formValues.selestecPlan) {
    errors.selestecPlan = !formValues.selectedGym ? "select gym" : "required";
  }

  if (formValues.isCustomAmount && !formValues.customMaxSellingPrice) {
    errors.customMaxSellingPrice = "required";
  }

  if (!formValues.offerPrice) {
    errors.offerPrice = "required";
  }

  if (offerPriceNumber > selectedPlanPriceNumber) {
    errors.offerPrice = "Offer price cannot be greater than max selling price";
  }

  return errors;
}

const OfferMappingForm = ({
  closeModal,
  callFunction,
  userInfoData,
  isEdit,
  rowData,
}) => {
  const dispatch = useDispatch();
  const { postPutLoading } = useSelector((state) => state.common);
  const { draftPlans, plansV0, plansLoadingV0, plansErrorV0 } = useSelector(
    (state) => state.plans
  );
  const gymData = useSelector(selectGymData);

  const [allGymPlans, setAllGymPlans] = useState([]);

  const forminitials = {
    selectedGym:
      isEdit && rowData?.gym_name && rowData?.gym_id
        ? {
            label: rowData.gym_name,
            value: rowData.gym_id,
          }
        : "",
    selestecPlan:
      isEdit && rowData?.plan_name && rowData?.plan_id
        ? {
            label: rowData.plan_name,
            value: rowData.plan_id,
            price: rowData.max_price || 0,
          }
        : "",
    customMaxSellingPrice: isEdit
      ? rowData?.custom_max_price
        ? rowData?.custom_max_price
        : ""
      : "",
    offerPrice: isEdit && rowData?.offer_value ? rowData?.offer_value : "",
    isCustomAmount: isEdit ? (rowData?.custom_max_price ? true : false) : false,
    isActive: isEdit ? (rowData?.status === "active" ? true : false) : false,
  };
  const [formValues, setFormValues] = useState(forminitials);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);

  const onChangeInput = (e) => {
    setIsSubmit(false);
    const { name, value, type, checked } = e.target;

    setFormValues((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const onChangeDropdown = (value, name) => {
    if (name === "selectedGym") {
      setFormValues({ ...formValues, selestecPlan: "", [name]: value });
    } else {
      setFormValues({ ...formValues, [name]: value });
    }
  };

  const onSubmit = () => {
    setFormErrors(validation(formValues));
    setIsSubmit(true);
  };

  const handleAdd = async (payload) => {
    const method = isEdit ? "PUT" : "POST";
    const endpoint = isEdit ? offer_mapping_PUT : offer_mapping_POST;
    const token = userInfoData?.token || "";

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        toast.success(result?.payload?.message || "Success!");
        setFormValues(forminitials);
        setIsSubmit(false);
        closeModal();
        callFunction();
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  function getAllDraftOffers(filters = {}) {
    dispatch(
      fetchPlansData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
    // dispatch(
    //   fetchAllDraftPlansData({
    //     filters: filters,
    //     token: userInfoData?.token,
    //   })
    // );
  }

  useEffect(() => {
    dispatch(fetchGymData(userInfoData?.token));
  }, []);

  useEffect(() => {
    if (formValues.selectedGym?.value) {
      getAllDraftOffers({
        page: 1,
        limit: 1000,
        status: "active",
        gym_id: formValues.selectedGym.value,
      });
    }
  }, [formValues.selectedGym]);

  useEffect(() => {
    if (!plansLoadingV0 && !plansErrorV0 && plansV0) {
      const dropdownOptions = plansV0?.data?.map((item) => ({
        label: item?.plan_name,
        value: item?.uid,
        price: item?.max_price || 0,
        info: item,
      }));

      setAllGymPlans(dropdownOptions || []);
    } else {
      setAllGymPlans([]);
    }
  }, [plansLoadingV0, plansErrorV0, plansV0]);

  useEffect(() => {
    if (isSubmit && Object.keys(formErrors)?.length === 0) {
      const userData = {
        gym_id: formValues.selectedGym?.value || "",
        plan_id: formValues.selestecPlan?.value || "",
        custom_max_price: formValues.isCustomAmount
          ? formValues.customMaxSellingPrice || 0
          : "",
        offer_value: formValues.offerPrice || 0,
        status: formValues.isActive ? "active" : "inactive",
      };

      if (isEdit) {
        userData.uid = rowData?.uid || "";
      }

      const handleConfirm = async () => {
        handleAdd(userData);
      };

      showConfirmAlert(
        handleConfirm,
        `Are you sure!
        `,
        "Edit Form",
        `${isEdit ? "Update" : "Add"} Offer`
      );
    }
  }, [isSubmit, formErrors]);

  return (
    <div className="createNewCTOModalContainer mealsModalContainer">
      <CommonHeadingNBtns
        title={`${isEdit ? "Update" : "Add"} Offer`}
        onClose={closeModal}
        btnTxt={isEdit ? "Update" : "Submit"}
        onClick={onSubmit}
        isLoading={postPutLoading}
      />

      <form className="formContainer">
        <div className="formInputsGrid fourGridSystem">
          <div className="formInputBox span2">
            <label htmlFor="selectedGym" className={`formInputLabel`}>
              gym name <span className="required">*</span>
            </label>

            <div
              className={`commonWrapper ${
                formErrors?.selectedGym ? "formError" : ""
              }`}>
              <SelectDropdown
                options={gymData?.length > 0 ? gymData : []}
                selectedOption={formValues.selectedGym}
                setSelectedOption={(selectedValue) =>
                  onChangeDropdown(selectedValue, "selectedGym")
                }
                name="Gym"
              />
            </div>
          </div>

          <div className="formInputBox">
            <label htmlFor="selestecPlan" className="formInputLabel">
              plan type <span className="required">*</span>
            </label>

            <div
              className={`commonWrapper ${
                formErrors?.selestecPlan ? "formError" : ""
              }`}>
              <SelectDropdown
                // options={
                //   draftPlans?.dropdown && draftPlans?.dropdown?.length > 0
                //     ? draftPlans.dropdown
                //     : []
                // }
                options={allGymPlans}
                selectedOption={formValues.selestecPlan}
                setSelectedOption={(selectedValue) =>
                  onChangeDropdown(selectedValue, "selestecPlan")
                }
                name="plan from the list"
                preventKeyboardOpen={true}
                isDisable={!formValues.selectedGym?.value}
              />
            </div>

            {formErrors?.selestecPlan && (
              <span className="error-label">
                {formErrors.selestecPlan || ""}
              </span>
            )}
          </div>

          <div className="formInputBox">
            <label htmlFor="price" className={`formInputLabel `}>
              max selling price
            </label>

            <input
              type="text"
              className={`formInput`}
              name="price"
              value={formValues.selestecPlan?.price || 0}
              disabled
              style={{
                backgroundColor: "#f0f0f0",
              }}
            />
          </div>

          {formValues.isCustomAmount && (
            <div className="formInputBox">
              <label
                htmlFor="customMaxSellingPrice"
                className={`formInputLabel`}>
                custom max selling price <span className="required">*</span>
              </label>

              <input
                type="number"
                className={`formInput ${
                  formErrors?.customMaxSellingPrice ? "formError" : ""
                }`}
                name="customMaxSellingPrice"
                placeholder="Enter custom max selling price"
                value={formValues.customMaxSellingPrice || ""}
                onChange={onChangeInput}
              />
            </div>
          )}

          <div className="formInputBox">
            <label htmlFor="offerPrice" className={`formInputLabel `}>
              offer amount (flat) <span className="required">*</span>
            </label>

            <input
              type="text"
              placeholder="Enter offer price"
              className={`formInput ${
                formErrors?.offerPrice ? "formError" : ""
              }`}
              name="offerPrice"
              value={formValues.offerPrice}
              onChange={onChangeInput}
            />

            {formErrors?.offerPrice && (
              <span className="error-label">{formErrors.offerPrice || ""}</span>
            )}
          </div>
        </div>

        <div className="formInputBox checkbox-wrapper span3">
          <div className={`flex-box`}>
            <label className="checkboxLabel">
              <input
                type="checkbox"
                name="isCustomAmount"
                checked={formValues.isCustomAmount}
                onChange={onChangeInput}
              />
              custom amount
            </label>

            <label className="checkboxLabel">
              <input
                type="checkbox"
                name="isActive"
                checked={formValues.isActive}
                onChange={onChangeInput}
              />
              Active
            </label>
          </div>
        </div>
      </form>
    </div>
  );
};

export default OfferMappingForm;
